import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/settings")({
  component: SettingsLayout,
});

const tabs = [
  { to: "/settings/profile", label: "Profile" },
  { to: "/settings/notifications", label: "Notifications" },
  { to: "/settings/account", label: "Account" },
  { to: "/settings/workspaces", label: "Workspaces" },
  { to: "/settings/team", label: "Team" },
  { to: "/settings/billing", label: "Billing" },
  { to: "/settings/integrations", label: "Integrations" },
  { to: "/settings/exports", label: "Exports" },
  { to: "/settings/support", label: "Support" },
] as const;

function SettingsLayout() {
  const path = useRouterState({ select: (r) => r.location.pathname });
  return (
    <div className="mx-auto max-w-5xl">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Manage your profile, workspaces, team, and billing.
        </p>
      </div>
      <div className="mb-6 flex flex-wrap gap-1 border-b border-border">
        {tabs.map((t) => {
          const active = path === t.to || path.startsWith(t.to + "/");
          return (
            <Link
              key={t.to}
              to={t.to}
              className={cn(
                "border-b-2 px-3 py-2 text-sm font-medium transition-colors -mb-px",
                active
                  ? "border-primary text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground",
              )}
            >
              {t.label}
            </Link>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
}
